<ng-container *ngIf="isLoading">
  <app-base-layout [showFooter]="false">
    <div class="waiting-body">
      <ng-container [ngSwitch]="loader">
        <span class="card-loader" *ngSwitchCase="'card'"></span>
        <span class="smilego-loader" *ngSwitchCase="'smilego'"></span>
        <mat-spinner
          [diameter]="100"
          class="color-spinner"
          *ngSwitchCase="'default'"
        ></mat-spinner>
      </ng-container>
      <h1>{{ waitingTitle ? waitingTitle : "" }}</h1>
      <h2>{{ waitingObservation }}</h2>
    </div>
  </app-base-layout>
</ng-container>
<ng-container *ngIf="!isLoading">
  <app-base-layout [showFooter]="false">
    <div class="waiting-body">
      <h1>
        Ooops. Ocorreu um erro inesperado. Clique
        <a [routerLink]="'/processamento'">aqui</a> para recarregar.
      </h1>
      <!-- <button
      (click)="onReloadPage()"
      class="btn-avancar">Recarregar<mat-icon>redo</mat-icon>
    </button> -->
    </div>
  </app-base-layout>
</ng-container>
<!-- <ng-container *ngIf="!isLoading">
  <app-image-capture
  (cancel)="onCancel($event)"
  (imageCapture)="onImageCapture($event)"
  *ngIf="captureOpen"
></app-image-capture>
<app-base-layout [showFooter]="false">
  <div class="review-page-content">
    <h1 style="margin: 0;">Tudo pronto, {{ name }}!</h1>
    <h2 style="color: var(--color-secondary);">Agora, é só revisar os seus dados e confirmar o envio.</h2>
    <div class="review-page-content-items">
      <div *ngFor="let item of formData; let i = index" class="review-page-content-items-item">
        <div *ngFor="let campo of item.values; let i = index" class="review-page-content-items-item">
          <h2>{{campo.field.titulo}}:</h2>
          <form
            (ngSubmit)="doEdit(campo.field)"
            *ngIf="
              field.codigo === campo?.field?.campoCodigo &&
              campo.field.tipo !== 'CAPTURA_IMAGEM'
            "
            [formGroup]="formGroup"
            class="review-page-content-edit"
          >
            <app-dynamic-input
              [campo]="field"
              [formGroup]="formGroup"
              [requestFocus]="true"
              [showLabel]="false"
            ></app-dynamic-input>
            <button
              (click)="cancelEdit(campo.field)"
              class="review-page-content-items-item-value-button"
              mat-icon-button
              type="button"
            >
              <mat-icon
                aria-hidden="false"
                aria-label="Cancelar"
                color="accent"
              >
                cancel
              </mat-icon>
            </button>
            <button
              [disabled]="!isValid(campo.field)"
              class="review-page-content-items-item-value-button"
              mat-icon-button
              type="submit"
            >
              <mat-icon
                aria-hidden="false"
                aria-label="Alterar"
                color="primary"
              >
                check
              </mat-icon>
            </button>
          </form>
          <div
            *ngIf="
              field.codigo !== campo?.field?.campoCodigo ||
              campo.field.tipo === 'CAPTURA_IMAGEM'
            "
            class="review-page-content-items-item-value"
          >
            <div [ngSwitch]="campo.type">
              <img
                *ngSwitchCase="'CAPTURA_IMAGEM'"
                [src]="getValue(campo.field)"
                alt="Imagem de {{ campo.name }}"
              />
              <mat-checkbox
                *ngSwitchCase="'BOLEANO'"
                [disableRipple]="true"
                [checked]="getValue(campo.field)"
                class="checkbox"
                color="primary"
                [disabled]="true"
              >
                {{ getFieldAttribute(campo.field, "PLACEHOLDER") }}
              </mat-checkbox>
              <p *ngSwitchDefault>{{ getValue(campo.field) }}</p>
            </div>

            <button *ngIf="!isLoading"
              (click)="edit(campo.field)"
              class="review-page-content-items-item-value-button"
              mat-button
            >
              <mat-icon
                aria-hidden="false"
                aria-label="Editar campo"
                class="review-page-content-items-item-value-button-icon"
              >
                edit
              </mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <button
      (click)="submitForm()"
      [disabled]="isLoading || field.codigo"
      class="review-page-content-next-button"
      color="primary"
      mat-raised-button
      type="submit"
    >
      <span *ngIf="!isLoading">Confirmar e enviar</span>
      <span *ngIf="isLoading">Enviando...</span>
      <mat-icon
        *ngIf="!isLoading"
        aria-hidden="false"
        aria-label="Enviar"
        class="review-page-content-next-button-icon"
        >check
      </mat-icon>
    </button>
  </div>
</app-base-layout>
</ng-container> -->
